module.exports = __webpack_public_path__ + "media/images/athletes/513-160e71bf1d646b1a8c70b417ba683647.png";